
// @ts-nocheck


export const localeCodes =  [
  "nl",
  "de"
]

export const localeLoaders = {
  nl: [
    {
      key: "locale_nl_46json_02a8d972",
      load: () => import("#nuxt-i18n/02a8d972" /* webpackChunkName: "locale_nl_46json_02a8d972" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_3b5291f9",
      load: () => import("#nuxt-i18n/3b5291f9" /* webpackChunkName: "locale_de_46json_3b5291f9" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/84a7542e" /* webpackChunkName: "config_i18n_46config_46js_84a7542e" */)
]

export const nuxtI18nOptions = {
  restructureDir: false,
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      name: "nederlands",
      code: "nl",
      language: "nl-NL",
      domain: "https://www.kotterliving.nl",
      files: [
        "/tmp/build_a0f4ef58/src/assets/i18n/nl.json"
      ]
    },
    {
      name: "deutsch",
      code: "de",
      language: "de-DE",
      domain: "https://www.koetterliving.de",
      files: [
        "/tmp/build_a0f4ef58/src/assets/i18n/de.json"
      ]
    }
  ],
  defaultLocale: "nl",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "assets/i18n/",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: true,
  baseUrl: "https://www.kotterliving.nl",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    name: "nederlands",
    code: "nl",
    language: "nl-NL",
    domain: "https://www.kotterliving.nl",
    files: [
      {
        path: "/tmp/build_a0f4ef58/src/assets/i18n/nl.json",
        cache: undefined
      }
    ]
  },
  {
    name: "deutsch",
    code: "de",
    language: "de-DE",
    domain: "https://www.koetterliving.de",
    files: [
      {
        path: "/tmp/build_a0f4ef58/src/assets/i18n/de.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/